import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../../helpers/datePickerConfig';
import ComponentCard from '../../../../layouts/containers/ComponentCard';
import SeccionIdentidad from './SeccionIdentidad';
import SeccionResidencia from './SeccionResidencia';
import SeccionNacimiento from './SeccionNacimiento';
import SeccionCentroContacto from './SeccionCentroContacto';

const DatosPersonalesForm = ({
  formik,
  age,
  document,
  country,
  province,
  poblationFiltered,
  poblationBirthFiltered,
  cpFiltered,
  formationCenter,
  fidelitationlist,
  idCedesca,
  idCntec,
  rowRef1,
  handleFechaNacimiento,
  handleProvinceChange,
  handlePoblationChange,
  handleBirthProvinceChange,
}) => (
  <ComponentCard title="Datos personales" hasButton>
    <SeccionIdentidad
      formik={formik}
      age={age}
      document={document}
      rowRef1={rowRef1}
      handleFechaNacimiento={handleFechaNacimiento}
    />
    <SeccionResidencia
      formik={formik}
      country={country}
      province={province}
      poblationFiltered={poblationFiltered}
      cpFiltered={cpFiltered}
      handleProvinceChange={handleProvinceChange}
      handlePoblationChange={handlePoblationChange}
    />
    <SeccionNacimiento
      formik={formik}
      country={country}
      province={province}
      poblationBirthFiltered={poblationBirthFiltered}
      handleBirthProvinceChange={handleBirthProvinceChange}
    />
    <SeccionCentroContacto
      formik={formik}
      formationCenter={formationCenter}
      fidelitationlist={fidelitationlist}
      idCedesca={idCedesca}
      idCntec={idCntec}
    />
  </ComponentCard>
);

DatosPersonalesForm.propTypes = {
  formik: PropTypes.object.isRequired,
  age: PropTypes.number.isRequired,
  document: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  country: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  province: PropTypes.array.isRequired,
  poblationFiltered: PropTypes.array.isRequired,
  poblationBirthFiltered: PropTypes.array.isRequired,
  cpFiltered: PropTypes.array.isRequired,
  formationCenter: PropTypes.array.isRequired,
  fidelitationlist: PropTypes.array.isRequired,
  idCedesca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idCntec: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rowRef1: PropTypes.object.isRequired,
  handleFechaNacimiento: PropTypes.func.isRequired,
  handleProvinceChange: PropTypes.func.isRequired,
  handlePoblationChange: PropTypes.func.isRequired,
  handleBirthProvinceChange: PropTypes.func.isRequired,
};

export default DatosPersonalesForm;
